import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Gaetano Aiello",
    role: "Titolare Caffe Aiello",
    text: "Professionista 'professionale' (che non e' da tutti), attivo, disponibile e paziente. Ho trovato in lui un ottimo partner insieme al suo team di specialisti. E' sempre stimolante lavorare con lui e da ogni incontro puo' sempre nascere una nuova idea.",
  },
  {
    name: "Annalisa Spadola",
    role: "CMO Caffe Moak Spa",
    text: "Antonio e' un grande lavoratore, arguto, preparato ed appassionato. Nella mia azienda si e' rivelato un'ottima risorsa. Capace di integrarsi velocemente e di fare gioco di squadra in modo intelligente.",
  },
  {
    name: "Francesco Alati",
    role: "Designer & Art Director",
    text: "Professionista serio e competente. Dimostra una solida visione d'insieme delle attivita' digital e di comunicazione strategica, integrando con efficacia competenze dalla pianificazione industriale alle strategie di go-to-market.",
  },
  {
    name: "Tiberia Perez",
    role: "Head of Products & Export Manager",
    text: "Antonio e' un professionista serio e preparato, il consulente che ogni azienda vorrebbe avere al suo fianco e l'alleato sicuro che ogni team di produzione Digital meriterebbe.",
  },
  {
    name: "Marco Ruta",
    role: "Export Manager - Area DACH",
    text: "Ho avuto il piacere di lavorare e collaboro ancora oggi con Antonio. Apprezzo la sua grande disponibilita' e competenza e la capacita' di trovare in tempi rapidi soluzioni efficienti per ogni problematica.",
  },
  {
    name: "Fortunato Aragona",
    role: "Sales Area Manager Webidoo Spa",
    text: "Mi piace come lavora perche' pensa a cosa e' giusto per il suo cliente e non alla sua tasca come fanno altri suoi 'colleghi'. Bravo Antonio!",
  },
];

function getInitials(name) {
  return name.split(" ").map(n => n[0]).join("").toUpperCase();
}

export default function TestimonialsSection() {
  return (
    <section id="testimonianze" data-testid="testimonials-section" className="py-24 md:py-32 bg-white">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-16">
          <p className="text-xs font-medium text-[#1B4332] uppercase tracking-wider mb-3">Testimonianze</p>
          <h2 className="text-3xl md:text-5xl font-semibold tracking-tight mb-4" style={{ fontFamily: 'Outfit', color: '#0F172A' }}>
            Cosa dicono di noi
          </h2>
          <p className="text-base md:text-lg text-slate-600 max-w-2xl mx-auto leading-relaxed">
            Le parole dei nostri clienti e partner sono la nostra migliore referenza.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.4 }}
              className="bg-slate-50 rounded-2xl p-8 border border-slate-100 relative group hover:shadow-md transition-all duration-300"
              data-testid={`testimonial-card-${i}`}
            >
              <Quote size={32} className="text-slate-200 absolute top-6 right-6" />

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} size={14} className="text-amber-400 fill-amber-400" />
                ))}
              </div>

              <p className="text-slate-600 leading-relaxed text-sm mb-6 relative z-10">
                "{t.text}"
              </p>

              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-[#1B4332] flex items-center justify-center flex-shrink-0">
                  <span className="text-white text-sm font-semibold">{getInitials(t.name)}</span>
                </div>
                <div>
                  <p className="font-semibold text-sm text-slate-900">{t.name}</p>
                  <p className="text-xs text-slate-500">{t.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
